import { h } from 'preact'

import PriceRating from '../price_rating'
import SearchResultImage from './image'

const SearchResult = ({ url, propertyType, featuredPhoto, name, bedrooms, bathrooms, maximumOccupancy, minPrice }) => {
  if (typeof window !== 'undefined') url = `${url}${window.location.search}`

  const infoLine = propertyType === 'resort'
    ? 'Multiple units available'
    : `${bedrooms} bed - ${bathrooms} bath - ${maximumOccupancy} people`

  return (
    <div class='col-sm-6 col-xl-4 mb-5 hover-animate'>
      <div class='card h-100 border-0 shadow'>
        <a href={url} class='tile-link' />
        <div class='card-img-top overflow-hidden gradient-overlay aspect-ratio-box'>
          <SearchResultImage url={featuredPhoto.url} alt={featuredPhoto.alt} />
        </div>
        <div class='card-body d-flex align-items-center'>
          <div class='w-100'>
            <h6 class='card-title'><span class='text-decoration-none text-dark'>{name}</span></h6>
            <div class='d-flex card-subtitle mb-3'>
              <p class='flex-grow-1 mb-0 text-muted text-sm'>{infoLine} - <PriceRating price={minPrice} /></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SearchResult
